import { Component, input, output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgbDropdown, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle } from '@ng-bootstrap/ng-bootstrap';
import { Device } from '../../models/device.model';
import { MdmLinkPipe } from '../pipes/mdm-link.pipe';

@Component({
  selector: 'era-device-action-bar-ui',
  templateUrl: './device-action-bar.component.html',
  imports: [RouterLink, NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownItem, FaIconComponent, MdmLinkPipe],
})
export class DeviceActionBarComponent {
  public readonly allowAssign = input(false);
  public readonly allowSpare = input(false);
  public readonly allowUnassign = input(false);
  public readonly allowUnavailable = input(false);

  public readonly allowHousekeeping = input(false);
  public readonly allowStaff = input(false);
  public readonly allowFrontDesk = input(false);
  public readonly allowBar = input(false);
  public readonly allowKiosk = input(false);

  public readonly device = input.required<Device>();
  public readonly notesEnabled = input(false);
  public readonly assignmentHistoryEnabled = input(false);

  public readonly openNotesModalEvent = output<object>();
  public readonly openAssignmentHistoryModalEvent = output<object>();

  openNotes() {
    this.openNotesModalEvent.emit({});
  }

  openAssignmentHistory() {
    this.openAssignmentHistoryModalEvent.emit({});
  }
}
